import type { GetWeeklyBreakdownRequestProps } from '@services/api/consumption/types'
import type { WeeklyBreakdownFormDataProps } from '../context/types'

export const parseWeeklyBreakdownPayload = (formData: WeeklyBreakdownFormDataProps) => {
  const payload: GetWeeklyBreakdownRequestProps = {
    filiCode: formData.filiCode,
    competenceDate: formData.competenceDate,
    page: formData.page,
    itemsPerPage: formData.itemsPerPage,
    sortBy: formData.sortBy,
    sortType: formData.sortType,
    supplierCodeFilter: formData.supplier ? (!Number(formData.supplier) ? [] : [formData.supplier]) : [],
    operationCodeFilter: formData.operation ? (!Number(formData.operation) ? [] : [formData.operation]) : [],
    originFilter: formData.origin ? (formData.origin === 'Todos' ? [] : [formData.origin]) : [],
    itemClassificationFilter: formData.classification
      ? formData.classification === 'Todos'
        ? []
        : [formData.classification]
      : []
  }

  return payload
}
